export const notificationStatuses = {
    error: {
        backgroundColor: 'error',
        borderColor: 'error',
        color: 'error',
        shadowColor: 'error',
        icon: 'warning',
    },
    info: {
        backgroundColor: 'secondary',
        borderColor: 'secondary',
        color: 'default',
        shadowColor: 'secondary',
        icon: 'info',
    },
    success: {
        backgroundColor: 'success',
        borderColor: 'success',
        color: 'success',
        shadowColor: 'success',
        icon: 'success',
    },
    warning: {
        backgroundColor: 'warning',
        borderColor: 'warning',
        color: 'warning',
        shadowColor: 'warning',
        icon: 'warning',
    },
    accent: {
        backgroundColor: 'accent',
        borderColor: 'primary',
        color: 'primary',
        shadowColor: 'primary',
        icon: 'accent',
    },
};
export const notificationVariants = {
    banner: {
        borderStyle: 'none',
        borderWidth: 'none',
        borderRadius: 'x1_5',
        padding: 'x3',
        width: '100%',
    },
    sectionBanner: {
        borderStyle: 'none',
        borderWidth: 'none',
        borderRadius: 'x0',
        padding: 'x3',
        width: '100%',
    },
    toast: {
        borderStyle: 'solid',
        borderWidth: 'sm',
        borderRadius: 'x1_5',
        padding: 'x3',
        width: 'fit-content',
    },
};
//# sourceMappingURL=notifications.js.map